export default {
  revenueType: Object.freeze({
    CASH_REGISTER_REVENUE_PERCENT: 'cash-register-revenue-percent', CASH_REGISTER_REVENUE_PERCENT_LABEL: '% от выручки',
    SERVICE_REVENUE: 'service-revenue', SERVICE_REVENUE_LABEL: 'начисления по услугам'
  }),
}
